import { KeyConstructor } from './keyConstructor';
const APP_KEY = 'app';
const GLOBAL_APP_KEY = 'global_app';
const APPS_KEY = 'apps';
const GLOBAL_APPS_KEY = 'global_apps';
const APP_NETWORK_SETTINGS = 'appNetworkSettings';
const APP_SPACE_SETTINGS = 'appSpaceSettings';
const APP_INSTALLATIONS_KEY = 'appInstallations';
const APP_COLLABORATORS_KEY = 'appCollaborators';
const APP_PUBLICATIONS_KEY = 'appPublications';
const DYNAMIC_BLOCK_KEY = 'dynamicBlock';
export const getAppKey = KeyConstructor(APP_KEY);
export const getGlobalAppKey = KeyConstructor(GLOBAL_APP_KEY);
export const getAppsKey = KeyConstructor(APPS_KEY);
export const getGlobalAppsKey = KeyConstructor(GLOBAL_APPS_KEY);
export const getPaginatedGlobalAppsKey = KeyConstructor(GLOBAL_APPS_KEY);
export const getAppNetworkSettingsKey = KeyConstructor(APP_NETWORK_SETTINGS);
export const getAppSpaceSettingsKey = KeyConstructor(APP_SPACE_SETTINGS);
export const getAppInstallationsKey = KeyConstructor(APP_INSTALLATIONS_KEY);
export const getAuthMemberAppInstallationKey = KeyConstructor(APP_INSTALLATIONS_KEY);
export const getAuthMemberAppInstallationsKey = KeyConstructor(APP_INSTALLATIONS_KEY);
export const getAppCollaboratorsKey = KeyConstructor(APP_COLLABORATORS_KEY);
export const getAppPublicationsKey = KeyConstructor(APP_PUBLICATIONS_KEY);
export const getDynamicBlockKey = KeyConstructor(DYNAMIC_BLOCK_KEY);
export const getDynamicBlockByKeyKey = KeyConstructor(DYNAMIC_BLOCK_KEY);
export const getAvailableDynamicBlocksKey = KeyConstructor(DYNAMIC_BLOCK_KEY);
//# sourceMappingURL=app.key.js.map